import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useAddPaymentMethodMutation } from "../../Services/PaymentmodeAPI";

function AddCategory() {
    const navigate = useNavigate();
    const [paymentMethodName, setPaymentMethodName] = useState(""); // Payment method name
    const [paymentMethodStatus, setPaymentMethodStatus] = useState(false); // Status for active/inactive
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);

    const [addPaymentMethods, { isLoading }] = useAddPaymentMethodMutation();

    const validateForm = () => {
        let newErrors = {};
        if (!paymentMethodName.trim()) newErrors.paymentMethodName = "Payment Method Name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ✅ Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return; // Stop if validation fails

        const formData = new FormData();
        formData.append("name", paymentMethodName); // Payment Method Name
        formData.append("status", paymentMethodStatus ? 1 : 0); // Status: 1 for active, 0 for inactive

        try {
            await addPaymentMethods(formData).unwrap();
            alert("Payment method added successfully!");
            // Reset form fields
            setPaymentMethodName("");
            setPaymentMethodStatus(false);
            setErrors({});
            setApiError(null);
            navigate("/paymentmethod-list");
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };
    

    return (
        <div>
            <h3>Add Payment Method</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/paymentmethod-list"><span>Back</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Add</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        {/* Payment Method Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="payment_method_name" className="form-label">Payment Method Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="payment_method_name"
                                    placeholder="Enter Payment Method Name"
                                    value={paymentMethodName}
                                    onChange={(e) => setPaymentMethodName(e.target.value)}
                                />
                                {errors.paymentMethodName && <p className="text-danger">{errors.paymentMethodName}</p>}
                            </div>
                        </div>

                        {/* Status (Active/Inactive) */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="status" className="form-label">Status</label>
                                <div>
                                    <label htmlFor="active" className="form-check-label">Active</label>
                                    <input
                                        type="radio"
                                        id="active"
                                        name="status"
                                        value={1}
                                        className="ml-5"
                                        checked={paymentMethodStatus === true}
                                        onChange={() => setPaymentMethodStatus(true)}
                                    />
                                    <label htmlFor="inactive" className="form-check-label ms-3">Inactive</label>
                                    <input
                                        type="radio"
                                        id="inactive"
                                        name="status"
                                        className="ml-5"
                                        value={0}
                                        checked={paymentMethodStatus === false}
                                        onChange={() => setPaymentMethodStatus(false)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
